export default __webpack_public_path__ + "static/media/Tirunelveli-Diocese.5daa1805.png";